import axios from 'axios';

export default {
	getReports() {
		return axios.get('/api/reports/');
	},
	getReportsByID(id) {
		return axios.get(`/api/reports/${id}`);
	},
	getReportsByDuty(dutyID) {
		return axios.get(`/api/reports/duty/${dutyID}`);
	},
	createReport(report) {
		return axios.post('/api/reports', report);
	},
	editReport(id, payload) {
		return axios.patch(`/api/reports/${id}`, payload);
	},
	deleteReport(id, changeComment) {
		return axios.delete(`/api/reports/${id}`, { data: { changeComment } });
	},
};
